import {CURSOR_MARK, MarkedInput, Options, Separator} from './types';

const parseNumeric = (input: MarkedInput, signed: boolean, options: Options) => {
  let numericString = input.filter(char => char !== CURSOR_MARK).join('');
  if (!numericString.length) return null;
  numericString = numericString.replace(options.radix, Separator.DOT);
  if (signed) numericString = '-' + numericString;
  return Number.parseFloat(numericString);
}

export default parseNumeric;
